 
import { Payload } from ".";
import { AppDispatch } from "../../configureStore";
import execute from "../http/execute";
import failure from "../http/failure";
import { del, get, put } from "../http/request";
import success from "../http/success";
import { UIAlert } from "../../interface/message";

 
const initialState: {
    turnTime?: string;
    isDev: boolean;
    showOnlyImportantFields: boolean;
    uiAlert?: UIAlert;
} = {
    isDev: false,
    showOnlyImportantFields: true,
};

export const GET_TURN_TIMES_REQUEST = 'ui/GET_TURN_TIMES_REQUEST';
export const GET_TURN_TIMES_SUCCESS = 'ui/GET_TURN_TIMES_SUCCESS';
export const GET_TURN_TIMES_FAILURE = 'ui/GET_TURN_TIMES_FAILURE';

export const SET_TURN_TIMES_REQUEST = 'ui/SET_TURN_TIMES_REQUEST';
export const SET_TURN_TIMES_SUCCESS = 'ui/SET_TURN_TIMES_SUCCESS';
export const SET_TURN_TIMES_FAILURE = 'ui/SET_TURN_TIMES_FAILURE';

export const SET_TEMP_TURN_TIME = 'ui/SET_TEMP_TURN_TIME';

export const GET_UI_ALERT_REQUEST = 'ui/GET_UI_ALERT_REQUEST';
export const GET_UI_ALERT_SUCCESS = 'ui/GET_UI_ALERT_SUCCESS';
export const GET_UI_ALERT_FAILURE = 'ui/GET_UI_ALERT_FAILURE';

export const SET_UI_ALERT_REQUEST = 'ui/SET_UI_ALERT_REQUEST';
export const SET_UI_ALERT_SUCCESS = 'ui/SET_UI_ALERT_SUCCESS';
export const SET_UI_ALERT_FAILURE = 'ui/SET_UI_ALERT_FAILURE';

export const DELETE_UI_ALERT_REQUEST = 'ui/DELETE_UI_ALERT_REQUEST';
export const DELETE_UI_ALERT_SUCCESS = 'ui/DELETE_UI_ALERT_SUCCESS';
export const DELETE_UI_ALERT_FAILURE = 'ui/DELETE_UI_ALERT_FAILURE';

export const SET_IS_DEV = 'ui/SET_IS_DEV';

export const SET_SHOW_ONLY_IMPORTANT_FIELDS = 'ui/SET_SHOW_ONLY_IMPORTANT_FIELDS';

type ActionParams =
    | { type: typeof SET_TEMP_TURN_TIME; time: string; }
    | { type: typeof GET_TURN_TIMES_SUCCESS; data: { current: string; } }
    | { type: typeof GET_UI_ALERT_SUCCESS; data: { currentAlert?: UIAlert; hasAlert: boolean; } }
    | { type: typeof DELETE_UI_ALERT_SUCCESS }
    | { type: typeof SET_IS_DEV; isDev: boolean; }
    | { type: typeof SET_SHOW_ONLY_IMPORTANT_FIELDS; showOnlyImportant: boolean; };

function reducer(state = initialState, action: ActionParams): typeof initialState {
    switch (action.type) {
        case SET_IS_DEV:
            return {
                ...state,
                isDev: action.isDev,
            };

        case SET_SHOW_ONLY_IMPORTANT_FIELDS:
            return {
                ...state,
                showOnlyImportantFields: action.showOnlyImportant,
            };

        case SET_TEMP_TURN_TIME: {
            return {
                ...state,
                turnTime: action.time,
            };
        }
        case GET_TURN_TIMES_SUCCESS: {
            return {
                ...state,
                turnTime: action.data.current,
            };
        }
        case GET_UI_ALERT_SUCCESS: {
            return {
                ...state,
                uiAlert: action.data.currentAlert,
            };
        }
        case DELETE_UI_ALERT_SUCCESS: {
            return {
                ...state,
                uiAlert: undefined,
            };
        }

        default: return state;
    }
}

export const getTurnTime = (payload: Payload<any>) => (dispatch: AppDispatch) => {
    dispatch({
        type: GET_TURN_TIMES_REQUEST,
        payload,
    });

    execute(get, `/turn-times`, payload.input, undefined, payload.overrideAuth)
        .then(success(dispatch, GET_TURN_TIMES_SUCCESS, payload))
        .catch(failure(dispatch, GET_TURN_TIMES_FAILURE, payload));
};

export const setTurnTime = (payload: Payload<{ current: string; }>) => (dispatch: AppDispatch) => {
    dispatch({
        type: SET_TURN_TIMES_REQUEST,
        payload,
    });

    execute(put, `/turn-times`, payload.input, undefined, payload.overrideAuth)
        .then(success(dispatch, SET_TURN_TIMES_SUCCESS, payload))
        .catch(failure(dispatch, SET_TURN_TIMES_FAILURE, payload));
};

export const getUIAlert = (payload: Payload<any>) => (dispatch: AppDispatch) => {
    dispatch({
        type: GET_UI_ALERT_REQUEST,
        payload,
    });

    execute(get, `/ui-alert`, payload.input, undefined, payload.overrideAuth)
        .then(success(dispatch, GET_UI_ALERT_SUCCESS, payload))
        .catch(failure(dispatch, GET_UI_ALERT_FAILURE, payload));
};

export const setUIAlert = (payload: Payload<UIAlert>) => (dispatch: AppDispatch) => {
    dispatch({
        type: SET_UI_ALERT_REQUEST,
        payload,
    });

    execute(put, `/ui-alert`, payload.input, undefined, payload.overrideAuth)
        .then(success(dispatch, SET_UI_ALERT_SUCCESS, payload))
        .catch(failure(dispatch, SET_UI_ALERT_FAILURE, payload));
};

export const deleteUIAlert = (payload: Payload<any>) => (dispatch: AppDispatch) => {
    dispatch({
        type: DELETE_UI_ALERT_REQUEST,
        payload,
    });

    execute(del, `/ui-alert`, payload.input, undefined, payload.overrideAuth)
        .then(success(dispatch, DELETE_UI_ALERT_SUCCESS, payload))
        .catch(failure(dispatch, DELETE_UI_ALERT_FAILURE, payload));
};

export default reducer;
